<template>
  <div>
    <div class="m-nav">
      <router-link class="home-page" :to="{name: 'Home'}">网站首页</router-link>
      <span v-for="name in navList" :key="name"> > {{ name }}</span>
    </div>
    <div v-if="navList.length">
      <span class="u-title">{{ navList[navList.length-1] }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navList: {
      type: Array,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .m-nav {
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    color: #000;
    border-bottom: 1px solid #ccc;
    .home-page{
      font-weight: 600;
    }
  }
  .u-title{
    display: inline-block;
    height: 40px;
    line-height: 24px;
    font-size: 16px;
    font-weight: 600;
    color: #9B181E;
    padding: 8px 24px;
    background: url("../../assets/images/party_icon.png") no-repeat left center;
    &:hover {
      color: #777;
    }
  }

</style>
